<template>
  <div class="plugin-wrapper">
    <div class="item-master item-tile item-tile item-wrapper item-detail" v-if="source && source.product_name">
      <!-- 图片 -->
      <div class="image-container tile__image-container">
        <!-- 用于分类列表组件使用: 图片+视频 -->
        <template v-if="source.image_show_type == 3 && (source.pc_kv_image || source.kv_image) && source.kv_video">
          <img class="tile-image tile__image lazyloaded" :src="( source.pc_kv_image || source.kv_image )+ '?x-oss-process=image/resize,w_900/quality,q_95'" :alt="source.product_name" />
          <video class="tile-video tile__video tile__video--hover" :src="source.kv_video" :poster="source.kv_video_image" />
        </template>
        <!-- 用于分类列表组件使用: 图片+图片 -->
        <template v-else-if="source.image_show_type == 2 && source.pc_kv_images && source.pc_kv_images.length > 0">
          <img class="tile-image tile__image lazyloaded" :src="source.pc_kv_images[0].url + '?x-oss-process=image/resize,w_900/quality,q_95'" :alt="source.product_name" />
          <img class="tile-image tile__image tile__image--hover lazyloaded" :src="source.pc_kv_images[1]?source.pc_kv_images[1].url:source.pc_kv_images[0].url + '?x-oss-process=image/resize,w_900/quality,q_95'" :alt="source.product_name" />
        </template>
        <!-- 用于分类列表组件使用: 图片+图片 》pc/h5 不显示这个 --> 
        <!-- <template v-else-if="source.image_show_type == 2 && source.kv_images && source.kv_images.length >= 2">
          <img class="tile-image tile__image lazyloaded" :src="source.kv_images[0].url + '?x-oss-process=image/resize,w_900/quality,q_95'" :alt="source.product_name" />
          <img class="tile-image tile__image tile__image--hover lazyloaded" :src="source.kv_images[1].url + '?x-oss-process=image/resize,w_900/quality,q_95'" :alt="source.product_name" />
        </template> -->
        <!-- 用于分类列表组件使用: 图片 -->
        <template v-else-if="source.image_show_type == 1 && (source.pc_kv_image || source.kv_image)">
          <img class="tile-image tile__image lazyloaded" :src="(source.pc_kv_image || source.kv_image) + '?x-oss-process=image/resize,w_900/quality,q_95'" :alt="source.product_name" />
        </template>
        <!-- 用于轮播组件使用 -->
        <template v-else-if="source.src && source.src.active">
          <img class="tile-image tile__image lazyloaded" :src="source.src.active + '?x-oss-process=image/resize,w_900/quality,q_95'" :alt="source.product_name" />
          <img v-if="source.src.hover" class="tile-image tile__image tile__image--hover lazyloaded" :src="source.src.hover + '?x-oss-process=image/resize,w_900/quality,q_95'" :alt="source.product_name" />
        </template>
      </div>
      <div class="tile__badges" v-if="source.badges && source.badges.length">
        <div v-for="(badge, index) in source.badges" :key="index" :class="['tile__badge', badge.clsName]" :style="badge.style">
          <span class="tile__badge-item">{{badge.text}}</span>
        </div>
      </div>
      <!-- 链接: 商品详情 -->
      <template v-if="source.unique_id || source.id">
        <router-link :to="`/detail?id=${source.unique_id || source.id}`" class="text--left tile__wrapper-link tile__wrapper-link-extended">
          <h3 class="pdp-link tile__name tile__name-link text--single_line" @click="hideSearchLayer">{{source.product_name}}</h3>
        </router-link>
      </template>
      <!-- 链接: CMS配置跳转 -->
      <template v-else-if="source.action">
        <a @click="actionHandler(source.action)" class="text--left tile__wrapper-link tile__wrapper-link-extended">
          <h3 class="pdp-link tile__name tile__name-link text--single_line">{{source.product_name}}</h3>
        </a>
      </template>
      <!-- 描述 -->
      <div class="tile-body tile__body">
        <p class="tile__description text--no-margin text--single_line">{{source.short_product_desc}}</p>
        <div class="tile-body-footer tile__tile-body-footer">
          <div class="tile__price-container">
            <div class="price tile__price">
              <div>
                <template v-if="originalPrice && originalPrice != sellingPrice">
                  <!-- <div class="strike-through list tile__price--strike-through btn--bold ">
                    <p class="text--no-margin">
                      <span class="sr-only">原价</span>
                      <span class="value">￥{{ originalPrice | toFixed(2) }}</span>
                    </p>
                  </div> -->
                  <div class="sales tile__price-sales btn--bold">
                    <p class="text--no-margin">
                      <span class="sr-only">售价</span>
                      <span class="value">￥{{ originalPrice | toFixed(2) }}</span>
                    </p>
                  </div>
                </template>
                <template v-else>
                  <div class="sales tile__price-sales btn--bold">
                    <p class="text--no-margin">
                      <span class="sr-only">售价</span>
                      <span class="value">￥{{ sellingPrice | toFixed(2) }}</span>
                    </p>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="tile__ratings" v-if="false">
            <p class="sr-only">Avis vérifiés: 4,722 étoiles sur 5</p>
            <div class="netreviews_review_rate_and_stars review__rating-stars">
              <div class="netreviews_review_rate_and_stars-empty review__empry-stars">
                <svg class="svg-inline star-empty" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18">
                  <path fill="#000" fill-rule="evenodd" d="M9 0L6.875 6.875H0l5.562 4.25L3.438 18 9 13.75 14.562 18l-2.124-6.875L18 6.875h-6.875z" opacity=".129"></path>
                </svg>
                <svg class="svg-inline star-empty" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18">
                  <path fill="#000" fill-rule="evenodd" d="M9 0L6.875 6.875H0l5.562 4.25L3.438 18 9 13.75 14.562 18l-2.124-6.875L18 6.875h-6.875z" opacity=".129"></path>
                </svg>
                <svg class="svg-inline star-empty" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18">
                  <path fill="#000" fill-rule="evenodd" d="M9 0L6.875 6.875H0l5.562 4.25L3.438 18 9 13.75 14.562 18l-2.124-6.875L18 6.875h-6.875z" opacity=".129"></path>
                </svg>
                <svg class="svg-inline star-empty" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18">
                  <path fill="#000" fill-rule="evenodd" d="M9 0L6.875 6.875H0l5.562 4.25L3.438 18 9 13.75 14.562 18l-2.124-6.875L18 6.875h-6.875z" opacity=".129"></path>
                </svg>
                <svg class="svg-inline star-empty" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18">
                  <path fill="#000" fill-rule="evenodd" d="M9 0L6.875 6.875H0l5.562 4.25L3.438 18 9 13.75 14.562 18l-2.124-6.875L18 6.875h-6.875z" opacity=".129"></path>
                </svg>
              </div>
              <div class="netreviews_review_rate_and_stars-gold review__filled-stars" title="Avis vérifiés: 4,722 étoiles sur 5">
                <svg class="svg-inline star-filled" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18">
                  <path fill="#000" fill-rule="evenodd" d="M9 0L6.875 6.875H0l5.562 4.25L3.438 18 9 13.75 14.562 18l-2.124-6.875L18 6.875h-6.875z"></path>
                </svg>
                <svg class="svg-inline star-filled" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18">
                  <path fill="#000" fill-rule="evenodd" d="M9 0L6.875 6.875H0l5.562 4.25L3.438 18 9 13.75 14.562 18l-2.124-6.875L18 6.875h-6.875z"></path>
                </svg>
                <svg class="svg-inline star-filled" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18">
                  <path fill="#000" fill-rule="evenodd" d="M9 0L6.875 6.875H0l5.562 4.25L3.438 18 9 13.75 14.562 18l-2.124-6.875L18 6.875h-6.875z"></path>
                </svg>
                <svg class="svg-inline star-filled" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18">
                  <path fill="#000" fill-rule="evenodd" d="M9 0L6.875 6.875H0l5.562 4.25L3.438 18 9 13.75 14.562 18l-2.124-6.875L18 6.875h-6.875z"></path>
                </svg>
                <svg class="svg-inline star-filled" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18">
                  <path fill="#000" fill-rule="evenodd" d="M9 0L6.875 6.875H0l5.562 4.25L3.438 18 9 13.75 14.562 18l-2.124-6.875L18 6.875h-6.875z"></path>
                </svg>
              </div>
            </div>
          </div>
          <div class="tile__btns" v-if="enableBuyNow">
            <template v-if="hasStock">
              <button class="c-button c-button--primary" @click="addToCart">立即购买</button>
            </template>
            <template v-else>
              <button class="c-button c-button--primary" disabled>已售罄</button>
            </template>
          </div>
        </div>
      </div>
      <!-- 收藏 -->
      <div class="tile__wishlist-btn" v-if="isLogin && enableFavorite">
        <button class="c-button c-button--icon add-to-wish-list" @click="toggleFavorites">
          <svg v-if="isCollected" class="svg-inline icon-heart-full" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
            <path fill="#000" fill-rule="evenodd" stroke="#0D0D0D" d="M11.875 1C10.57 1 9.317 1.662 8.5 2.708 7.683 1.662 6.43 1 5.125 1 2.815 1 1 2.978 1 5.496c0 3.09 2.55 5.608 6.413 9.433L8.5 16l1.087-1.079C13.45 11.104 16 8.586 16 5.496 16 2.978 14.185 1 11.875 1z" />
          </svg>
          <svg v-else class="svg-inline icon-heart-empty" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
            <path fill="none" fill-rule="evenodd" stroke="#0D0D0D" d="M11.875 1C10.57 1 9.317 1.662 8.5 2.708 7.683 1.662 6.43 1 5.125 1 2.815 1 1 2.978 1 5.496c0 3.09 2.55 5.608 6.413 9.433L8.5 16l1.087-1.079C13.45 11.104 16 8.586 16 5.496 16 2.978 14.185 1 11.875 1z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import acitonMixins from "@/utils/action.mixins";
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";

export default {
  name: "BaseItem",
  mixins: [acitonMixins],
  props: {
    source: {
      type: Object,
      required: true
    },
    enableFavorite: {
      type: Boolean,
      default: false
    },
    enableBuyNow: {
      type: Boolean,
      default: false
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    toggleFavorites() {
      let xhrTypes = types.FAV_ADD;
      let state = 1;
      if (this.isCollected) {
        xhrTypes = types.FAV_DEL;
        state = 0;
      }
      api[xhrTypes]({
        pid: this.source.unique_id,
        type: /collection/i.test(this.source.display_type) ? 2 : 1
      }).then(res => {
        if (res.code == 1) {
          this.syncFavPids();
          this.$emit("favorite", {
            ref: this.source.unique_id,
            state
          });
        } else if (res.code != 2) {
          this.$toast({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    syncFavPids() {
      this.$store.dispatch(types.FAV_PIDS_LIST);
    },
    addToCart() {
      let sku_id = -1;
      if (['collection'].indexOf(this.source.display_type) != -1) {
        sku_id = `{{${this.source.unique_id}}}${this.source.products.reduce((pre, currItem) => {
          // return pre + `{{${currItem.skus[0].sku_id}}}`
          return pre + `{{${currItem.skus.find(sku => sku.stock > 0).sku_id}}}`;
        }, '')}`;
      } else if (['collection_sku'].indexOf(this.source.display_type) != -1) {
        sku_id = this.source.skus[0].sku_id;
      } else {
        sku_id = this.source.skus.find(sku => sku.stock > 0).sku_id;
      }
      // 
      if (sku_id && sku_id != -1) {
        if (this.isLogin) {
          api[types.CART_ADD]({
            id: sku_id,
            quantity: 1
          }).then(res => {
            let { code } = res;
            if (code == 1) {
              this.toSyncCartInfo();
            } else if (code != 2) {
              this.$toast({ message: res.message, iconCls: "failure" });
            }
          }).catch(err => {
            console.warn(err);
          });
        } else {
          utils.addToCart({
            id: sku_id,
            quantity: 1,
            price: this.sellingPrice
          }, (localCart, errMsg) => {
            this.toSyncCartInfo(errMsg);
          });
        }
      } else {
        console.log(this.source);
        let id = this.targetId()
        if (this.isLogin) {
          api[types.CART_ADD]({
            id: id,
            quantity: 1
          }).then(res => {
            let { code } = res;
            if (code == 1) {
              this.toSyncCartInfo();
            } else if (code != 2) {
              this.$toast({ message: res.message, iconCls: "failure" });
            }
          }).catch(err => {
            console.warn(err);
          });
        } else {
          utils.addToCart({
            id: id,
            quantity: 1,
            price: this.source.lowest_ori_price
          }, (localCart, errMsg) => {
            this.toSyncCartInfo(errMsg);
          });
        }
      }
    },
    toSyncCartInfo(errMsg) {
      errMsg && this.$toast({ message: errMsg, iconCls: "failure" });
      this.$store.dispatch(types.CART_GET, () => {
        this.$router.push({ path: '/cart' });
        this.hideSearchLayer()
      });
    },
    hideSearchLayer() {
      this.$emit('hideSearchLayer')
    },
    targetId(){
      this.type = this.source.display_type
      let targetId = ''
      // 组合礼盒
      if (this.type == "collection") {
        this.source.products.forEach(element => {
          targetId +=  `{{${element.skus[0].sku_id}}}`
        });
        targetId = `{{${this.source.unique_id}}}`+targetId;
        console.log(targetId)
      } else if (this.type == "collection_sku") {
        targetId = this.source.skus[0].sku_id;
      } else if (["capacity_ml", "capacity_g", "color"].indexOf(this.type) != -1) {
        // 正常商品 & 固定礼盒
        targetId = this.source.skus[0].sku_id;
      } else {
        // TODO:: 特殊商品 => 梳子
        targetId = this.source.skus[0].sku_id;
      }
      return targetId
    },
    report4AddToCart() {
      api[types.REPORT_ADD_TO_CART]({ product_id: this.source.unique_id }).then(res => {
        if (res.code != 1) {
          console.warn('[REPORT_ADD_TO_CART]: ', res);
        }
      });
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    // 是否收藏
    isCollected() {
      return this.$store.state?.favPids?.indexOf(this.source?.unique_id) != -1;
    },
    originalPrice() {
      if (["capacity_ml", "capacity_g", "color"].indexOf(this.source.display_type) != -1 || !this.source.display_type) {
        return this.source?.skus?.[0]?.ori_price || this.source.highest_ori_price;
      } else if (this.source.display_type == "collection_sku") {
        return this.source?.lowest_ori_price;
      } else if (this.source.display_type == "collection") {
        return this.source?.products.reduce((previous, current) => {
          let isFreebie = current.is_freebie;
          return previous + (isFreebie ? 0 : parseFloat(current?.skus?.[0].ori_price||0));
        }, 0);
      } else {
        return 0;
      }
    },
    sellingPrice() {
      if (["capacity_ml", "capacity_g", "color"].indexOf(this.source.display_type) != -1 || !this.source.display_type) {
        return this.source?.skus?.[0]?.price || this.source.highest_price;
      } else if (this.source.display_type == "collection_sku") {
        return this.source?.lowest_price;
      } else if (this.source.display_type == "collection") {
        return this.source?.products?.reduce((previous, current) => {
          let isFreebie = current.is_freebie;
          return previous + (isFreebie ? 0 : parseFloat(current?.skus?.[0].price||0));
        }, 0);
      } else {
        return 0;
      }
    },
    hasStock() {
      return this.source.max_stock > 0;
    }
  }
}
</script>

<style lang="scss" scoped>
  .item-tile { position: relative; max-width: 100%; }
  .tile__image { width: 100%; }
  .tile__image--hover { display: none; position: absolute; top: 0; }
  .tile__video--hover { display: none; position: absolute; top: 0; left: 0; width: 100%; height: 100%; }
  .tile__badges { position: absolute; left: .625rem; top: .625rem; text-align: left; }
  .tile__badge { font-family: HelveticaNeueLTW05-75Bold,arial,sans-serif; font-size: .625rem; text-transform: uppercase; letter-spacing: .0625rem; margin-bottom: .3125rem; }
  .tile__badge-item { border: .0625rem solid #8c8c8c; background-color: transparent; padding: .125rem .3125rem; color: #575757; display: inline; }
  .tile__wrapper-link { display: inline-block; overflow: hidden; text-decoration: none; width: 100%; font-family: HelveticaNeueLTW05-45Light,arial,sans-serif; font-size: .8125rem; }
  .tile__wrapper-link--extended:before { content: ""; width: 100%; height: 100%; top: 0; left: 0; position: absolute; z-index: 1; }
  .tile__name { color: #000; margin-top: .3125rem; overflow: hidden; text-transform: none; }
  .tile__name-link { color: #000; text-decoration: none; font-family: HelveticaNeueLTW05-45Light,arial,sans-serif; font-size: .8125rem; line-height: 1.3; margin-bottom: 0; letter-spacing: normal; }
  .tile__name-link:after { content: ""; position: absolute; left: 0; top: 0; right: 0; bottom: 30px; z-index: 1; }
  .tile__body { text-align: left; position: relative; }
  .tile__description { font-size: .75rem; height: 2.25rem; overflow: hidden; color: #575757; }
  .tile__tile-body-footer { margin-top: .625rem; display: flex; justify-content: space-between; align-items: center; }
  .tile__price-container { font-size: .75rem; font-family: HelveticaNeueLTW05-75Bold,arial,sans-serif; white-space: nowrap; }
  .tile__price { margin-right: .625rem; }
  .tile__price--strike-through { margin-right: .625rem; color: #575757; text-decoration: line-through; display: inline-block; }
  .tile__price-sales { color: #000; display: inline-block; }
  .tile__ratings { height: 1.0625rem; overflow: hidden; display: flex; align-items: center; }
  .tile__btns {
    .c-button { padding: 0.5rem; }
  }
  .netreviews_review_rate_and_stars { display: flex; align-items: center; padding: 0; margin: 0; height: 30px; min-height: 30px; position: relative; line-height: 1; }
  .netreviews_review_rate_and_stars-empty, .netreviews_review_rate_and_stars-gold { display: flex; align-items: center; width: 80px; }
  .netreviews_review_rate_and_stars-gold { position: absolute; left: 0; top: 50%; transform: translateY(-50%); font-size: 13px; }
  // 
  .tile__badges {
    .tile__badge--colors-count .tile__badge-item { border-color: #904749; background-color: #904749; color: #fff; }
  }
  .tile__wrapper-link {
    .tile__name-link { letter-spacing: normal; }
  }
  .tile__wishlist-btn {
    position: absolute; right: 0.3125rem; top: 0.3125rem; z-index: 1;
    .c-button--icon { border: none; border-radius: 0; padding: 0; }
  }
  .tile__image-container{
    position: relative; height: 0; overflow: hidden; padding-bottom: 132%;
  }
  @media screen and (min-width: 48em) {
    .tile__name { margin-top: .75rem; }
    .tile__name-link { font-size: 1rem; }
    .tile__name-link:after { bottom: 40px; }
    .tile__description { font-size: .8125rem; height: 1.25rem; }
    .tile__tile-body-footer { max-height: none; margin-top: .625rem; }
    .tile__price-container { margin-right: .625rem; }
    .tile__btns {
      .c-button { padding: 0.8125rem 1.875rem; }
    }
    .tile__wishlist-btn { right: 0.625rem; top: 0.625rem; }
  }
  @media screen and (min-width: 64em) {
    .item-tile { max-width: 24.3125rem; margin: 0 auto; }
    .tile__wrapper-link:hover { text-decoration: underline; }
    .tile__description { height: 1.125rem; }
    .item-tile {
      &:hover {
        .tile__image--hover { display: block; }
        .tile__video--hover { display: block; }
      }
    }
    .tile__wishlist-btn { right: 1.25rem; top: 1.25rem; }
  }
</style>